<template>
    <div class="address_content">
        <div class='type'>
            <div class='express' :class='{active:sendFrom.sendType == 40}' @click='changeType(40)'>
                <img :src='"/images/newOrder/che" + checkImg(40) + ".png"' alt="" />
                <span>顺丰上门</span>
                <p class='triangle-bottomright' v-show='sendFrom.sendType!=10'></p>
            </div>
            <div class='courier' :class='{active:sendFrom.sendType==10}' @click='changeType(10)'> 
                <img :src='"/images/newOrder/kuaidi" + checkImg(10) + ".png"' alt="" />
                <span>自己快递</span>
                <p class='triangle-bottomright' v-show='sendFrom.sendType==10'></p>
            </div>

        </div>
        <div class='address_title'>
            <p>{{sendFrom.sendType==10?'包拯地址':'取件地址'}}</p>
            <div class='tel_content' @click='adrshowAction'>
                <div v-show='sendFrom.sendType==10' @click='adrshowAction'>包拯工作室 17526857604 </div>
                <div v-show='sendFrom.sendType == 40' @click='adrshowAction'>
                    {{defultAdr.contacts}}  {{defultAdr.mobile}}
                </div>
                <div v-if='sendFrom.sendType == 40 && JSON.stringify(defultAdr) == "{}"' @click.stop="$router.push({ name: 'addressEdit',query:{ins:'bag'}})"> 
                    <span class='addAdr'>新建地址</span>
                    <img src='/images/public/arrow-right.png'>
                    
                </div>
                <img src='/images/public/arrow-right.png' @click='adrshowAction' v-else>
            </div>
            <div v-if='sendFrom.sendType == 40' @click='adrshowAction'>
                
                {{defultAdr.province}}{{defultAdr.city}}{{defultAdr.district}}{{defultAdr.address}}
            </div>
            <div v-else @click='adrshowAction'>
                天津市武清区开发区武清逸仙园小区翠柳道6号（包拯修复中心）
            </div>
        </div>
        <div class='choseType' v-if='sendFrom.sendType!=10' @click="timeShowAction">
            <div class='expressTypeTitle'>
                上门取件时间
            </div>
            <div class='expressTypeTitle'>
                {{pickingDateFormShow}}    {{pickingDateForm.time}}
                <img src='/images/public/more.png'>
            </div>
            
        </div>



        <van-popup v-model="timeShow" position="bottom" :overlay="true" overlay-class='overlay'>
            <van-picker :columns="showpickDateList" 
                @change="onTimeChange" 
                show-toolbar
                @cancel="show = false"
                @confirm="onConfirm"
                ref="dateTimePicker"
            />
        </van-popup>


        <van-popup position="bottom" v-model="adrShow" overlay-class='overlay'>
            <div class="containerAdr f28">
                <div class="ctitle">{{sendFrom.sendType==10?'邮递地址':'选择地址'}}</div>
         
                <div class="close" @click="adrshowHide"></div>
                <div class="addr-container">
                    <ul v-if='sendFrom.sendType==40'>
                        <li v-for='(item,index) in adrList' :key='index' @click='adrClick(index)'>
                            <div class='li_div'>
                                <radio :checked='item.isDefault'/>
                            </div>
                            <addr-com :model='item' :selected='item.trueDefault' :ins='"bag"' @toEditAdr="$router.push({ name: 'addressEdit',query:{aid:item.id}})"/>
                        </li>
                    </ul>
                    

                    <div class='myadrcontent' v-else>
                        <p>收件人： 包拯工作室</p>
                        <p>电话： 17526857604</p>
                        <p>地址： 天津市武清区开发区武清逸仙园小区翠柳道6号（包拯修复中心）</p>
                    </div>
                    

                </div>
               
                
            </div>
            <div class='adrTips'>*{{$store.state.takeSendCity}}、沈阳、重庆{{$store.state.takeSendNum}}城包邮</div>
            <button class="primary fr outsideBtn" @click="$router.push({ name: 'addressEdit',query:{ins:'bag'}})" v-show='sendFrom.sendType==40'>添加地址</button>
            <!-- <button class="secondary fr mysendBtn outsideBtn" @click='changeType'>{{type==10?'顺丰上门':'自己快递'}}</button> -->
        </van-popup>
    </div>
</template>

<script>
    import { Toast } from 'vant'
    import myApi from '@/axios/my'
    import homeApi from '@/axios/home'
    export default {
        name: 'select-address',
        props: {
            sendFrom: {
                type: Object,
                default:function(){
                    return {
                        sendType : 40,
                        customerAddressId : '',
                        pickingDate : '',
                        pickingTime : '',
                    }
                }
            },
        },
        data () {
            return {

                pickDateList : [],
                pickTimeList : [],
                showpickDateList : [
                    {
                        values: [],
                    },
                    {
                        values: [],
                    }
                ],
                pickingDateForm:{
                    data : '',
                    time : ''
                },
                pickingDateFormShow:'',
                adrList : [],
                timeShow : false,
                adrShow : false,
                actionNow : false
            }
        },
        computed: {
            defultAdr(){
                let items = '';
                this.adrList.forEach((item,index)=>{
                    if(item.isDefault){
                        items = item;
                    }
                })
                if(items){
                    this.$emit('changeAdr',items)
                    return items;
                }else{
                    this.$emit('changeAdr',{})
                    return {};
                }
            },
            currFullAddress() {
                const {
                    province,
                    city,
                    district,
                    address
                } = this.defultAdr
                if(province && city && district) {
                    return province + city + district + address
                }
                return ''
            }
        },
        created () {
            this.getAdressList();
        },  
        methods: {
            adrshowAction(){
                if(this.sendFrom.sendType == 40 && JSON.stringify(this.defultAdr) == "{}"){
                    this.$router.push({ name: 'addressEdit',query:{ins:'bag'}});
                    return;
                }
                
                this.adrShow = true;
                this.$emit('showShade');
            },
            adrshowHide(){
                this.adrShow = false;
           
                this.$emit('hiddenShade');
            },
            timeShowAction(index){
                if(!this.currFullAddress) {
                    Toast('请先填写取件地址')
                    return
                }
                this.listPickDateAndTime(this.pickingDateForm.data).then(() => {
                    if(index == 1){
                        this.actionNow = true;
                    }else{
                        this.actionNow = false;
                    }
                    this.timeShow = true;
                    this.$emit('showShade')
                }).catch(err => {
                    Toast('获取取件时间失败:' + (err && err.message || ''))
                })
            },
            timeShowHide(){
                this.timeShow = false;
                this.$emit('hiddenShade');
            },
            adrClick(index){
                this.adrList.forEach((element,idx) => {
                    if(index == idx){
                        element.isDefault = true;
                        
                    }else{
                        element.isDefault = false;
                    }
                });
                // this.adrShow = false;
                this.adrshowHide();
                this.clearDateTime();
            },
            onConfirm([date, time], index){
                this.pickingDateForm.data = date.value;
                this.pickingDateForm.time = time.value;
                this.pickingDateFormShow = date.text;
                this.$emit('changeDate',date.value,time.value);
                
                // this.timeShow = false;
                this.timeShowHide();
                console.log(this.actionNow)
                if(this.actionNow){
                    this.$emit('action')
                }
            },
            onTimeChange(picker, [date, time] , index){
                //改变第一列
                if(index == 0){
                    //获取到data重新拉去数据
                    this.listPickDateAndTime(date.value).catch(err => {
                        picker.setColumnValues(1, [])
                        Toast('获取取件时间失败:' + (err && err.message || ''))
                    })
                }
            },
            listPickDateAndTime(date){
                if(!this.currFullAddress) {
                    return
                }
                const params = {
                    address: this.currFullAddress
                }
                if(date){
                    params.sendTime = date;
                }
                return homeApi.listPickDateAndTime(params).then((res)=>{
                    if(res.code === '000000') {
                        this.pickDateList = res.data.pickDateList;
                        this.pickTimeList = res.data.pickTimeList;
                
                        const dateArr = this.pickDateList.map(item => ({
                            text: item.pickDateText,
                            value: item.pickDate
                        }));

                        const timeArr = this.pickTimeList.map(item => ({
                            text: item.pickTimeText,
                            value: item.pickTime
                        }));

                        if (this.showpickDateList[0].values.length > 0){
                            this.$refs.dateTimePicker.setColumnValues(0, dateArr);
                        } else {
                            this.showpickDateList[0].values = dateArr
                        }
                        
                        
                        if(this.showpickDateList[1].values.length > 0) {
                            this.$refs.dateTimePicker.setColumnValues(1, timeArr);
                        }else{
                            this.showpickDateList[1].values = timeArr;
                        }
                    } else {
                        return Promise.reject(res)
                    }
                })
            },
            clearDateTime() {
                this.pickingDateFormShow = ''
                this.pickingDateForm.data = ''
                this.pickingDateForm.time = ''
                if(this.$refs.dateTimePicker) {
                    this.$nextTick(() => {
                        this.$refs.dateTimePicker.setColumnIndex(0,0)
                        this.$refs.dateTimePicker.setColumnIndex(1,0)
                    })
                }
            },
            changeType(type){
                // this.sendType = type;
                this.$emit('changeType',type);
        
            },
            checkImg(index){
                return this.sendFrom.sendType==index?2:1
            },
            getAdressList(){
                myApi.customerAddress({}).then((res)=>{
                    let defaultNum = 0;
                    let index = 0;
                    let mostTime = '1970-01-01'
                    res.forEach((element,index)=>{
                        element.trueDefault = element.isDefault;
                        if(element.isDefault){
                            defaultNum++;
                        }
                        let mostDate = new Date(mostTime).getTime();
                        let elementDate = new Date(element.updateTime).getTime();
                        if(elementDate>mostDate){
                            mostTime = element.updateTime;
                            index = index;
                        }
                    })

                    if(defaultNum == 0 && res[index]){
                        res[index].isDefault = true;
                    }

                    this.adrList = res;
                    
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    .overlay{
        // position:fixed;
        // height: 800px;
        // background: red;
    }
    .addAdr{
        margin-right: 20px;
        line-height: 40px;
        position: relative;
        top:-6px;
    }
    .outsideBtn{
        margin-bottom: 20px;
        margin-top: 20px;
        float: right;
        margin-right:30px;
    }
    .tel_content{
        display: flex;
        justify-content: space-between;
        margin-top: 40px!important;
        img{
            width:14px;
            height: 24px;
        }
    }
    .active{
        border: 1px solid #7ADFDF!important;
        span{
            color:#7ADFDF!important;
        }
    }
    .triangle-bottomright {
        width: 0;
        height: 0;
        border-bottom: 40px solid #7ADFDF;
        border-left: 40px solid transparent;
        position: absolute;
        bottom:0;
        right: 0;
    }
    .address_content{
        padding: 40px;
        padding-bottom: 20px;
        .type{
            display: flex;
            justify-content: space-between;
            div{
                width: 48%;
                border-radius:10px;
                height: 94px;
                border: 1px solid #C9C8C8;
                position: relative;
                text-align: center;
                display: flex;
                justify-content:center;
                align-items: center;
                // vertical-align: center;
                // padding-top: 40px;
                img{
                    width: 50px;
                    height: 50px;
                    // margin-top: 20px;
                    margin-right:22px;
                }
                span{
                    line-height: 50px;
                    font-size:28px;
                    color:#C9C8C8;
                }
            }
        }
    }
    .address_title{
        p{
            font-size: 36px;
            color:#4A4A4A;
            font-weight:600;
            margin-top: 40px;
        }
        &>div{
            margin-top: 20px;
            margin-bottom: 20px;
        }
    }
    .choseType{
      
        color:#4A4A4A;
        font-size: 28px;
        display: flex;
        justify-content:space-between;
        line-height: 28px;
        margin-top: 30px;
        padding-right:50px;
        padding-top: 20px;
        // font-weight:600;
        position: relative; 
        border-top: 1px solid #eee;
        .expressTypeTitle{
            color:#4A4A4A;
       
            font-size: 24px;
            line-height: 50px;
        }
        img{
            width:35px;
            position: absolute;
            right: 0;
            top:40px;
        }
    }
    .containerAdr{
        max-height: 860px;
        padding: 32px;
        position: relative;
        padding-bottom:60px;
        padding-top: 0px;
        .ctitle{
            line-height: 90px;
            border-bottom:1px solid #EEEEEE;
            font-size: 28px;
            font-weight:500
            }
            &>span{
                position:absolute;
                right:30px;
                top:80px;
                color:#7ADFDF;
            }
            .addr-container{
                max-height: 700px;
                overflow-y: scroll;
            ul li{
                width: 100%;
                display: flex;
                padding-top:32px;

                // align-items: center;
            }
        }
        .close{
            width: 36px;
            height: 36px;
            position: absolute;
            top: 30px;
            right: 30px;
            background: url("/images/public/close.png") no-repeat center;
            background-size: 32px;
        }
        .submit{
            position: absolute;
            bottom: 30px;
            right: 30px;
        }
    }
    .adrTips{
        background: #F3FBFB;
        padding:16px 30px;
        color:#4A4A4A;
        font-size: 24px;
        line-height: 40px;
    }
    .myadrcontent{
            width:670px;
            margin-bottom: 50px;
            background:rgba(255,255,255,1);
            box-shadow:0px 1px 10px 0px rgba(0,0,0,0.1);
            border-radius:3px;
            padding-top:50px;
            padding-bottom:50px;
            margin-top:30px;
            margin-left: 5px;
        p{
            font-size: 30px;
            margin-bottom: 20px;
            margin-top:20px;
            margin-left:50px; 
        }
    }
</style>
